import { normalizeLocale, sourceLocale } from "@hallyulytics/i18n";
import type { LoaderFunctionArgs, RouteObject } from "react-router";
import { HomePage } from "./pages/HomePage";
export async function homeLoader({ request }: LoaderFunctionArgs) {
  const locale = normalizeLocale(request.headers.get("x-hallyulytics-locale")) ?? sourceLocale;
  const checks = fetch(new URL("/api/v1/admin/services", request.url), {
    signal: request.signal,
  }).then(async (response) => {
    if (!response.ok) throw new Error("Admin checks unavailable");
    return response.json() as Promise<Record<string, "ok" | "unavailable">>;
  });
  return { locale, checks };
}
export const routes: RouteObject[] = [{ path: "/", loader: homeLoader, Component: HomePage }];
